// 项目分析文件列表模块
import request from '../request.js'

// 获取文件列表、报告列表 --- 郑志会
const getFileList = function (data) {
    return request({
        url: 'sysFile/selectAllFile',
        method: 'post',
        data
    })
}

// 批量删除文件记录 --- 郑志会
const deleteFile = function (data) {
    return request({
        url: 'sysFile/deleteById',
        method: 'post',
        data
    })
}

// 批量下载 --- 李开明
const downloadFile = function (data) {
    return request({
        url: 'sysFile/batchDownloadFiles',
        method: 'post',
        data
    })
}

// 生成报告 保存接口 --- 李开明
const saveReport = function (data) {
    return request({
        url: 'sysFileService/saveReport',
        method: 'post',
        data
    })
}


export {
    getFileList,
    deleteFile,
    downloadFile,
    saveReport
}